import React from 'react';
import { VideoGridContainer } from './styled';

function VideoGridSection(props) {
  const { data } = props;
  return (
    <VideoGridContainer>
      <img src={data?.sectionBgImage} alt="" />
      <video playsInline autoPlay muted={true} loop>
        <source src={data?.videoUrlData?.videoUrlWeb} />
      </video>
    </VideoGridContainer>
  );
}

export default VideoGridSection;
